import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, FieldArray, Form } from 'formik';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text, Button, Modal } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import {
  updateAgency,
  setAgencyLinks,
} from '@rsos/reduxDataStore/src/features/alertsRouting/alertsRoutingSlice';
import { notifyError } from '@rsos/utils/toastUtils';
import { alertTypeFormatter } from '../../utils';
import { INBOUND } from '../../utils';
import {
  ScrollableContainer,
  Checkbox,
  SectionTitle,
  RowText,
} from './EditPairModal.styles';

const EditPairModal = ({ isOpened, onClose, authority, type, alertTypes }) => {
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;

  const handleCheckbox = (e, arrayHelpers, type, values) => {
    if (e.target.checked) arrayHelpers.push(type);
    else {
      const idx = values.alertTypes.indexOf(type);
      arrayHelpers.remove(idx);
    }
  };
  const handleClose = handleReset => {
    handleReset();
    onClose();
  };

  const handleEditAuthorityPair = values => {
    const data = {
      org,
      id: authority.id,
      alert_emergency_types: values.alertTypes,
    };
    dispatch(updateAgency(data))
      .then(unwrapResult)
      .then(() => {
        dispatch(setAgencyLinks({ ...data, type }));
        onClose();
      })
      .catch(error => {
        notifyError(error);
      });
  };

  const initialValues = {
    alertTypes:
      type === INBOUND
        ? alertTypes
        : authority?.attributes?.alert_emergency_types,
    agencyName: authority.link_from.display_name,
  };
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, { resetForm }) => {
        handleEditAuthorityPair(values, resetForm);
      }}
    >
      {({ values, handleBlur, handleReset, setFieldValue }) => (
        <Modal
          isOpened={isOpened}
          onClose={() => handleClose(handleReset)}
          width={400}
          id="modal-edit-pair"
          disableBackdropClick
        >
          <>
            <ModalHeader onClose={() => handleClose(handleReset)}>
              <Box width={400}>
                <Text size="xlarge" color="primaryText">
                  Edit {type === INBOUND ? 'Inbound' : 'Outbound'} Alert Types
                </Text>
              </Box>
            </ModalHeader>
            <ModalBody>
              <Form id="editPairForm">
                <InputText
                  name="name"
                  id="name"
                  label="Agency Name"
                  value={values.agencyName}
                  onBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  isDisabled={true}
                  shouldDisplayClearButton={false}
                />
                <ScrollableContainer errorBorder={!values.alertTypes.length}>
                  <FieldArray name="alertTypes">
                    {arrayHelpers => (
                      <div
                        id="alert-types-checkbox-group"
                        aria-labelledby="alert-types-checkbox-group"
                        role="group"
                      >
                        <SectionTitle>Alert type</SectionTitle>
                        {alertTypes.map(type => (
                          <Box horizontal align="center" py={13} key={type}>
                            <Checkbox
                              type="checkbox"
                              data-name={type}
                              name={type}
                              value={type}
                              checked={
                                !!values.alertTypes.find(p => p === type)
                              }
                              onChange={e =>
                                handleCheckbox(e, arrayHelpers, type, values)
                              }
                            />
                            <RowText>{alertTypeFormatter(type)}</RowText>
                          </Box>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </ScrollableContainer>
                {!values?.alertTypes.length && (
                  <Box horizontal flow={5} color="lightDanger" mt="8px">
                    <AttentionTriangleIcon height={12} width={12} />
                    <Text size="small" color="lightDanger">
                      At least 1 Alert type is required
                    </Text>
                  </Box>
                )}
              </Form>
            </ModalBody>
            <ModalFooter flow={12}>
              <Button btnType="tertiary" onClick={onClose} grow noMargin>
                Cancel
              </Button>
              <Button
                onClick={() => {}}
                noMargin
                grow
                type="submit"
                form="editPairForm"
                disabled={!values?.alertTypes.length}
              >
                Save changes
              </Button>
            </ModalFooter>
          </>
        </Modal>
      )}
    </Formik>
  );
};

export default EditPairModal;
